// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".item__icon[data-v-e2c93644] {\n  width: 36px;\n  height: 36px;\n}\n.item__title[data-v-e2c93644] {\n  -webkit-box-orient: vertical;\n  display: -webkit-box;\n  overflow: hidden;\n  white-space: normal;\n  -webkit-line-clamp: 2;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
